import { FileConnectQueueBanner } from '@liscio/common';
import { createTheme, ThemeProvider, useViewportSize } from '@liscio/ui';

import useGenerateExternalUrl from 'hooks/useGenerateExternalUrl';

// The shared banner is styled with the Liscio design-system palette, which the legacy root theme
// does not define; nest that theme as other shared surfaces in legacy do.
const liscioTheme = createTheme();

export interface FileConnectBannerProps {
  isEmployee: boolean;
}

/**
 * The app-wide FileConnect banner on legacy pages. Its link opens the firm app's Files page on
 * Inbox → FileConnect; shown only where that page exists (desktop) and only
 * to firm employees (this layout also wraps client sessions, whose count request would 404).
 */
export const FileConnectBanner = ({ isEmployee }: FileConnectBannerProps) => {
  const { isMobile } = useViewportSize();
  const fileConnectQueueUrl = useGenerateExternalUrl('/files', {
    extraParams: { view: 'list', source: 'file_connect' },
  });

  return (
    <ThemeProvider theme={liscioTheme}>
      <FileConnectQueueBanner
        enabled={!isMobile && isEmployee}
        queueLink={{ href: fileConnectQueueUrl }}
      />
    </ThemeProvider>
  );
};

export default FileConnectBanner;
